import {
  CommonModule,
  LocationStrategy,
  PathLocationStrategy,
  registerLocaleData,
} from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localept from '@angular/common/locales/pt';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  LOCALE_ID,
  NgModule, isDevMode,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  ApmErrorHandler,
  ApmModule,
  ApmService,
} from '@elastic/apm-rum-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

import { ServiceWorkerModule } from '@angular/service-worker';
import {
  NgxMaskDirective,
  NgxMaskPipe,
  provideEnvironmentNgxMask,
} from 'ngx-mask';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpInterceptorService } from './core/services/interceptors/http-interceptor.service';
import { SharedModule } from './shared/shared.module';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app'; // 8.2.1. Import provideFirebaseApp e initializeApp
import { provideMessaging, getMessaging } from '@angular/fire/messaging'; // 8.2.2. Import provideMessaging e getMessaging


/** Config locale pt-Br */
registerLocaleData(localept, 'pt');

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    ApmModule,
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    NgxSpinnerModule,
    SharedModule,
    ToastrModule.forRoot({
      positionClass: 'my-toast-top-right',
      toastClass: 'ngx-toastr custom-toast',
    }),
    NgxMaskDirective,
    NgxMaskPipe,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    CommonModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'pt',
    },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    {
      provide: ErrorHandler,
      useClass: ApmErrorHandler,
    },
    ApmService,
    provideEnvironmentNgxMask(),
    provideFirebaseApp(() => initializeApp(environment.firebase)), // 8.2.4. Inicializa o Firebase App
    provideMessaging(() => getMessaging()), // 8.2.5. Fornece o serviço Messaging

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule { }
